(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8002],{

/***/ 68481:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fad';
var iconName = 'shield-check';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f2f7';
var svgPathData = ['M16 139.7c.5 99.5 41.3 281 213.6 363.5c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c0-26.4-16.4-47.9-38.3-57.2L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8C32.4 92.1 16 113.6 16 139.7zM136 256c0-6.1 2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l47 47c37-37 74-74 111-111c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7c2.3 2.3 4.1 5 5.3 7.9c.6 1.4 1 2.9 1.3 4.4c.2 1.1 .3 2.2 .3 2.2c.1 1.2 .1 1.2 .1 2.5c-.1 1.5-.1 1.9-.1 2.3c-.1 .7-.2 1.5-.3 2.2c-.3 1.5-.7 3-1.3 4.4c-1.2 2.9-2.9 5.6-5.3 7.9c-42.7 42.7-85.3 85.3-128 128c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7c-21.3-21.3-42.7-42.7-64-64c-4.7-4.7-7-10.8-7-17z', 'M369 175c9.4 9.4 9.4 24.6 0 33.9L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0z'];

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.ip = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 92449:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/success",
      function () {
        return __webpack_require__(24292);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 61835:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/brake-icon-black.72841916.png","height":104,"width":104,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAJFBMVEUAAAAAAAAAAAAAAAAAAAAAAABMaXEAAAAAAAAAAAAAAAAAAABjcfp2AAAADHRSTlMklEMUPVwANXSHLgifTpxgAAAACXBIWXMAAAsTAAALEwEAmpwYAAAANklEQVR4nAXBhwEAMAjDMEPY/f/fStQjJ1U8x4kRoR7rSAKz3UvabXYyca1ZA3dy5EVd0PHqAyrHATHF+85eAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 13158:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/clock-icon-black.8593e169.png","height":102,"width":102,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAGFBMVEUAAAAAAABMaXEAAAAAAAAAAAAAAAAAAACTHuQbAAAACHRSTlMdgwB4LkMM2tiHsmgAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAzSURBVHicLcvBDQAwDMJAAyHdf+OqUn9+nPFEypjRwmoIbk0QTo0Q230RbHvy8Slvx+UCFpcAovYVFYEAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 38177:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/document-icon-black.6c5dbd61.png","height":100,"width":100,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAHlBMVEUAAAAAAAAZGx5MaXEAAAAICAoAAAAAAAAAAAAqLjNy/OB4AAAACnRSTlN1SSYATTIUZEVxfGYjswAAAAlwSFlzAAALEwAACxMBAJqcGAAAADZJREFUeJwVyrkRwEAMA7GlSD3Xf8MeZwiABSDTzGzRKHZYIblmflwxTsjVe6XQVPeffexy/gAa8ADZ0apvBQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 32997:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/google-logo-icon.b6a61d5c.png","height":100,"width":100,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAYFBMVEVMaXEzqFL9wQPpRDgyqEtAh/DqQzSwcC5AhfUyqFNBkvjzuQlAjdZDh/PnQjXTTFHJtxrqQjTpQDf5nBJGjvzuRzzqPDcpplj/HwBEhPVHj/88sH85tllfu0z/YjL8STnuslihAAAAGnRSTlMA4qfkWluuBrOoEeufRGA1VlidVX/3e3YYzvaoMGsAAAAJcEhZcwAACxMAAAsTAQCanBgAAABASURBVHicJcZFAoAwDADBLZUkuEux//+SA3MakCGlVoDx9X7pYHpWZAeKilJV458jz/T3BjE3YJdzZw1IMAvCB1t2Anv9m9fyAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 29001:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/like-shaped-icon-black.fde2bee1.png","height":100,"width":100,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAJ1BMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADdEvm1AAAADXRSTlMBFGh4YoQ9mEAjLkZF1R7ZDgAAAAlwSFlzAAALEwAACxMBAJqcGAAAADdJREFUeJwVy7cRwEAQA7EleeZl+q9XI+QAZAugMqcLFFVo4bPbnqKezZ0plNe5InDPtP8ml+ADHSkA1J54/2wAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 82705:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/receipt-discount-icon-black.beb5dd68.png","height":100,"width":100,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAALVBMVEUAAAAAAABMaXEAAAAAAAAjKCwAAAAEBAQAAAAkJi0AAAAAAAAtMTgAAAAAAAAGRdQ6AAAAD3RSTlMyIgBhWxx9D491S3RaBS5M/0jYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAOUlEQVR4nCXIxw3AMBADMElXXfcf1wjCJ6GZa+UUmBUVScCCOxyAaQwZAI9N/nPON+w27yZ0y72uHiwbATncGi31AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 80734:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/shield-tick-icon-black.e9703e42.png","height":102,"width":102,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAGFBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABWNxwqAAAACHRSTlMDOXYaimUqW6ySz/wAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAxSURBVHicHYvJDQAgEISYY9f+Ozb6IwQA2QLwbMaggTBCB5XzoftM+sIG1N3+LXbgAhLfAIjtnVJmAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 5426:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/nubrakes-van-house-800-num.3fec1ca8.jpg","height":571,"width":1003,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAP/xAAeEAABBAEFAAAAAAAAAAAAAAABAAIDEQUGISIxYf/EABUBAQEAAAAAAAAAAAAAAAAAAAID/8QAFxEBAQEBAAAAAAAAAAAAAAAAAQACMf/aAAwDAQACEQMRAD8AloyspkG48vlhAYS6Vj+ZHdDagL8KIinsBl2//9k=","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 68663:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H4": function() { return /* binding */ YelpButton; },
/* harmony export */   "Ig": function() { return /* binding */ ButtonOutline; },
/* harmony export */   "Op": function() { return /* binding */ ViewAllCitiesButton; },
/* harmony export */   "zx": function() { return /* binding */ Button; }
/* harmony export */ });
/* unused harmony export LearnMoreButton */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);






var Button = function(_param) {
    var children = _param.children, className = _param.className, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "className",
        "disabled"
    ]);
    var disabledClassName = "disabled:bg-green-300 disabled:cursor-not-allowed";
    var baseClassName = "inline-block justify-center bg-lime hover:bg-green-600 text-white py-2 text-lg font-semibold px-5 rounded";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        disabled: disabled,
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(baseClassName, disabledClassName, className)
    }, rest), {
        children: children
    }));
};
var LearnMoreButton = function(param) {
    var children = param.children;
    var baseClassName = "ml-1 inline-block justify-center bg-blue-900 text-white text-sm px-2 rounded";
    return /*#__PURE__*/ _jsx("button", {
        className: classNames(baseClassName),
        children: children
    });
};
var ButtonOutline = function(_param) {
    var children = _param.children, className = _param.className, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "className",
        "disabled"
    ]);
    var disabledClassName = "opacity-50 cursor-not-allowed";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        disabled: disabled,
        className: "".concat(className, " border-primary hover:text-white border inline-block justify-center bg-transparent hover:bg-primary text-primary py-2 text-lg font-semibold px-5 rounded ").concat(disabled ? disabledClassName : "")
    }, rest), {
        children: children
    }));
};
var YelpButton = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: "inline-block w-full md:w-auto  border-gray-800 border justify-center bg-transparent hover:bg-gray-800 hover:text-white text-gray-800 py-2 text-lg font-semibold px-5 rounded",
        children: children
    });
};
var ViewAllCitiesButton = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: "inline-block border-allCitiesGray border justify-center bg-transparent hover:bg-allCitiesGray hover:text-white text-allCitiesGray py-2 text-lg font-semibold px-5 rounded",
        children: children
    });
};


/***/ }),

/***/ 14399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FAQ; },
/* harmony export */   "v": function() { return /* binding */ FAQSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60357);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67814);
/* harmony import */ var _fortawesome_free_brands_svg_icons_faCcVisa__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73977);
/* harmony import */ var _fortawesome_free_brands_svg_icons_faCcAmex__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(63543);
/* harmony import */ var _fortawesome_free_brands_svg_icons_faCcDiscover__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(83708);
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3210);
/* harmony import */ var react_animate_height__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68133);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(59417);
/* harmony import */ var _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93024);













var FAQSection = function(param) {
    var title = param.title, description = param.description;
    /*React.useEffect(() => {
    if (iFrameResize)
      iFrameResize({ checkOrigin: false, heightCalculationMethod: 'taggedElement' }, '#SP_cmFDSnceVq2r7aASVGuT')
  }, [iFrameResize])*/ return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "jsx-d85d3d4a3bb65347" + " " + "text-center bg-gray-50",
        children: [
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "d85d3d4a3bb65347",
                children: ".title.jsx-d85d3d4a3bb65347{font-size:40px;color:#000;font-weight:700}.description.jsx-d85d3d4a3bb65347{font-size:18px;color:#7c7c7c;font-weight:400}@media(max-width:768px){.title.jsx-d85d3d4a3bb65347{font-size:24px;color:#000;font-weight:700}}"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Container__WEBPACK_IMPORTED_MODULE_4__/* .Container */ .W, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "jsx-d85d3d4a3bb65347",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: "jsx-d85d3d4a3bb65347" + " " + "title max-w-xs mx-auto lg:max-w-full",
                                children: title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "jsx-d85d3d4a3bb65347" + " " + "description",
                                children: description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "jsx-d85d3d4a3bb65347" + " " + "grid grid-cols-1 md:grid-cols-2 gap-6",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FAQ, {
                                question: "What does your quote include?",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "jsx-d85d3d4a3bb65347",
                                        children: "At NuBrakes, transparency is at the core of our process. Your quote includes everything: parts, labor, and taxes."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "jsx-d85d3d4a3bb65347",
                                        children: "After providing a preliminary quote, your technician will perform a thorough in-person inspection to confirm the recommended repairs, ensuring no surprises."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FAQ, {
                                question: "How does the diagnosis work?",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "jsx-d85d3d4a3bb65347",
                                        children: "We’ll provide a preliminary diagnosis over the phone or via text to guide the next steps. During your appointment, your technician will perform a thorough inspection and determine the final recommended repairs."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "jsx-d85d3d4a3bb65347",
                                        children: "They’ll walk you through their findings, explain everything clearly, and provide a detailed inspection report. You’ll receive the report before making any decisions, ensuring full transparency and control."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "jsx-d85d3d4a3bb65347",
                                        children: "Once you’ve reviewed the findings, discussed your options, and authorized the work, we’ll get started right away. With NuBrakes, you’re always in the driver’s seat, and we aim to have you back on the road in no time."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FAQ, {
                                question: "Who handles the repairs?",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "jsx-d85d3d4a3bb65347",
                                    children: "Your vehicle will be serviced by NuBrakes-certified technicians with years of hands-on experience in brake repair. Each technician is a trusted member of our team, ensuring your vehicle is in expert hands."
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FAQ, {
                                question: "What type of parts do you use?",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "jsx-d85d3d4a3bb65347",
                                        children: "We typically match the brake pad type to your vehicle’s Original Equipment Manufacturer (OEM) specifications, whether ceramic or semi-metallic. We always use Platinum-grade parts or better to ensure optimal braking performance and reliability."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "jsx-d85d3d4a3bb65347",
                                        children: "If you have specific preferences or questions about the parts used, we’re happy to discuss bespoke options tailored to your needs. At NuBrakes, your safety and satisfaction are our top priorities."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FAQ, {
                                question: "Do you offer a warranty",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "jsx-d85d3d4a3bb65347",
                                    children: [
                                        "Absolutely! All repairs are backed by our ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_6___default()), {
                                            href: "/warranty",
                                            children: "NuBrakes Guarantee"
                                        }),
                                        ", which includes a warranty of up to 2 years / 24,000 miles. You can drive with confidence knowing your brakes are built to last."
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FAQ, {
                                question: "Do you do any other auto repairs?",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "jsx-d85d3d4a3bb65347",
                                        children: "While our primary focus is providing expert brake repairs and brake service, we also offer other essential maintenance items, such as oil changes and battery replacements. Unlike traditional repair shops, we don’t push unnecessary upsells—just honest, straightforward care to keep your vehicle running smoothly."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "jsx-d85d3d4a3bb65347",
                                        children: "If you have other service needs, speak to your service advisor—they’ll be happy to help explore how we can assist you."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FAQ, {
                                question: "How do I pay for my repairs?",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "jsx-d85d3d4a3bb65347" + " " + "px-3",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "jsx-d85d3d4a3bb65347" + " " + "answer",
                                            children: "We make payment easy and convenient—no credit card is required to schedule your appointment. Once your service is complete, you can pay on-site using any major credit or debit card. We also offer flexible financing options to make it even easier to get the repairs you need. We do not accept cash as a payment method."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "jsx-d85d3d4a3bb65347",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                                                    icon: _fortawesome_free_brands_svg_icons_faCcVisa__WEBPACK_IMPORTED_MODULE_7__/* .faCcVisa */ .k9,
                                                    className: "mx-1",
                                                    size: "2x"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                                                    icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_8__/* .faCcMastercard */ .N$R,
                                                    className: "mx-1",
                                                    size: "2x"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                                                    icon: _fortawesome_free_brands_svg_icons_faCcAmex__WEBPACK_IMPORTED_MODULE_9__/* .faCcAmex */ .ve,
                                                    className: "mx-1",
                                                    size: "2x"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                                                    icon: _fortawesome_free_brands_svg_icons_faCcDiscover__WEBPACK_IMPORTED_MODULE_10__/* .faCcDiscover */ .fp,
                                                    className: "mx-1",
                                                    size: "2x"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var FAQ = function(param) {
    var question = param.question, children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var height = isOpen ? "auto" : 0;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex flex-col flex-grow",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "text-left rounded-md overflow-hidden border border-gray-200",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "px-4 py-3 h-100 bg-white",
                        style: {
                            cursor: "pointer"
                        },
                        onClick: function() {
                            return setIsOpen(!isOpen);
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex pr-4",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                                        icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_11__/* .faPlus */ .r8p,
                                        className: "mx-1",
                                        size: "1x"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "question mb-0",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                        className: "capitalize",
                                        children: question
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_animate_height__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        duration: 350,
                        height: height,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "py-4 bg-white",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "answer px-3",
                                    children: children
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 12640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hb": function() { return /* binding */ CustomNumberField; },
/* harmony export */   "Jt": function() { return /* binding */ CustomFormControl; },
/* harmony export */   "__": function() { return /* binding */ Label; },
/* harmony export */   "g8": function() { return /* binding */ PhoneNumberField; },
/* harmony export */   "yM": function() { return /* binding */ CustomTextField; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(82175);
/* harmony import */ var capital_case__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71292);
/* harmony import */ var _util_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6069);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61275);










var Label = function(_param) {
    var children = _param.children, className = _param.className, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "children",
        "className"
    ]);
    var defaultClasses = "font-bold text-gray-500";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(defaultClasses, className)
    }, rest), {
        children: children
    }));
};
var CustomFormControl = function(_param) {
    var tmp = _param.as, Component = tmp === void 0 ? "input" : tmp, _type = _param.type, type = _type === void 0 ? "text" : _type, _pattern = _param.pattern, pattern = _pattern === void 0 ? null : _pattern, classNameParent = _param.className, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "as",
        "type",
        "pattern",
        "className"
    ]);
    var className = "block w-full rounded px-4 py-1 border-gray-300 border form-control-height";
    var variantClasses = "disabled:bg-gray-200 focus:style-outline-primary focus:outline-none";
    var asClassName = (0,ramda__WEBPACK_IMPORTED_MODULE_4__/* .cond */ .wVM)([
        [
            (0,ramda__WEBPACK_IMPORTED_MODULE_4__/* .equals */ .fS0)("select"),
            (0,ramda__WEBPACK_IMPORTED_MODULE_4__/* .always */ .Bxt)("bg-white leading-tight")
        ],
        [
            (0,ramda__WEBPACK_IMPORTED_MODULE_4__/* .equals */ .fS0)("textarea"),
            (0,ramda__WEBPACK_IMPORTED_MODULE_4__/* .always */ .Bxt)("")
        ],
        [
            (0,ramda__WEBPACK_IMPORTED_MODULE_4__/* .equals */ .fS0)("input"),
            (0,ramda__WEBPACK_IMPORTED_MODULE_4__/* .always */ .Bxt)("")
        ],
        [
            ramda__WEBPACK_IMPORTED_MODULE_4__.T,
            (0,ramda__WEBPACK_IMPORTED_MODULE_4__/* .always */ .Bxt)("")
        ], 
    ])(Component);
    var customProps = (0,ramda__WEBPACK_IMPORTED_MODULE_4__/* .reject */ .d1t)(ramda__WEBPACK_IMPORTED_MODULE_4__/* .isNil */ .kKJ)({
        type: type,
        pattern: pattern
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, customProps), {
        className: classNameParent !== null && classNameParent !== void 0 ? classNameParent : classnames__WEBPACK_IMPORTED_MODULE_3___default()(className, asClassName, variantClasses)
    }), rest));
};
var CustomTextField = function(_param) {
    var required = _param.required, field = _param.field, subLabel = _param.subLabel, customLabel = _param.customLabel, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "required",
        "field",
        "subLabel",
        "customLabel"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "mb-3",
        children: [
            subLabel ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Label, {
                        className: "mb-0 pb-0",
                        children: [
                            customLabel !== null && customLabel !== void 0 ? customLabel : capital_case__WEBPACK_IMPORTED_MODULE_8__/* .capitalCase */ .I(field.name),
                            required ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                style: {
                                    color: "red"
                                },
                                children: " *"
                            }) : ""
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "pb-2",
                        style: {
                            fontSize: 13,
                            marginTop: -2,
                            color: "gray"
                        },
                        children: subLabel
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Label, {
                children: [
                    capital_case__WEBPACK_IMPORTED_MODULE_8__/* .capitalCase */ .I(customLabel ? customLabel : field.name),
                    required ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        style: {
                            color: "red"
                        },
                        children: " *"
                    }) : ""
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CustomFormControl, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, field, props)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_9__/* .ErrorMessage */ .Bc, {
                render: function(errorMessage) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        style: {
                            color: "red"
                        },
                        children: errorMessage
                    });
                },
                name: field.name
            })
        ]
    });
};
var CustomNumberField = function(_param) {
    var required = _param.required, field = _param.field, form = _param.form, subLabel = _param.subLabel, customLabel = _param.customLabel, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "required",
        "field",
        "form",
        "subLabel",
        "customLabel"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "mb-3",
        children: [
            subLabel ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Label, {
                        className: "mb-0 pb-0",
                        children: [
                            capital_case__WEBPACK_IMPORTED_MODULE_8__/* .capitalCase */ .I(customLabel ? customLabel : field.name),
                            required ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                style: {
                                    color: "red"
                                },
                                children: " *"
                            }) : ""
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "pb-2",
                        style: {
                            fontSize: 13,
                            marginTop: -2,
                            color: "gray"
                        },
                        children: subLabel
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Label, {
                children: [
                    capital_case__WEBPACK_IMPORTED_MODULE_8__/* .capitalCase */ .I(customLabel ? customLabel : field.name),
                    required ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        style: {
                            color: "red"
                        },
                        children: " *"
                    }) : ""
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CustomFormControl, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, field, props), {
                onChange: function(e) {
                    var val = e.target.value.replace(/[^\d]/g, "");
                    form.setFieldValue(field.name, val);
                }
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_9__/* .ErrorMessage */ .Bc, {
                render: function(errorMessage) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        style: {
                            color: "red"
                        },
                        children: errorMessage
                    });
                },
                name: field.name
            })
        ]
    });
};
var PhoneNumberField = function(_param) /*#__PURE__*/ {
    var required = _param.required, label = _param.label, field = _param.field, form = _param.form, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "required",
        "label",
        "field",
        "form"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "mb-3",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Label, {
                children: [
                    label ? label : capital_case__WEBPACK_IMPORTED_MODULE_8__/* .capitalCase */ .I(field.name),
                    required ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        style: {
                            color: "red"
                        },
                        children: " *"
                    }) : ""
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CustomFormControl, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                type: "tel",
                /* prettier-ignore */ pattern: "[0-9-]+"
            }, field, props), {
                onChange: function(e) {
                    var val = (0,_util_util__WEBPACK_IMPORTED_MODULE_2__/* .normalizePhone */ .UK)(e.target.value);
                    form.setFieldValue(field.name, val);
                }
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_9__/* .ErrorMessage */ .Bc, {
                render: function(errorMessage) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        style: {
                            color: "red"
                        },
                        children: errorMessage
                    });
                },
                name: field.name
            })
        ]
    });
};


/***/ }),

/***/ 28763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ HappinessGuaranteeSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67814);
/* harmony import */ var _fortawesome_pro_duotone_svg_icons_faShieldCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68481);
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3210);





var HappinessGuaranteeSection = function(param) {
    var description = param.description, title = param.title, _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? "#fff3f0" : _backgroundColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "text-center",
        style: {
            backgroundColor: backgroundColor
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Container__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G, {
                    icon: _fortawesome_pro_duotone_svg_icons_faShieldCheck__WEBPACK_IMPORTED_MODULE_4__/* .faShieldCheck */ .ip,
                    color: "#f04f23",
                    size: "7x"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: "py-4 title",
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "description",
                    children: description
                })
            ]
        })
    });
};


/***/ }),

/***/ 39925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ StarsAndRatings; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_star_rating_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64396);
/* harmony import */ var react_star_rating_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_star_rating_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67814);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59417);




var StarsAndRatings = function(param) {
    var withPoints = param.withPoints;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
        className: "mt-1 flex items-center justify-center",
        style: {
            lineHeight: 1
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_star_rating_component__WEBPACK_IMPORTED_MODULE_1___default()), {
                name: "rating",
                value: 5,
                starCount: 5,
                starColor: "gold",
                editing: false,
                renderStarIcon: function(index, value) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: index <= value ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G, {
                            icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_3__/* .faStar */ .Tab,
                            color: "gold"
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G, {
                            icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_3__/* .faStar */ .Tab,
                            color: "gold"
                        })
                    });
                },
                renderStarIconHalf: function() {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G, {
                            icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_3__/* .faStarHalf */ .eJY,
                            color: "gold"
                        })
                    });
                }
            }),
            withPoints && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "text-white font-bold ml-2",
                children: "4.9"
            })
        ]
    });
};


/***/ }),

/***/ 18037:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ nestBackendClient; }
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87066);

var nestBackendClient = axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].create */ .Z.create({
    baseURL: "https://prod.v1.api.nubrakes-backend.com/"
});


/***/ }),

/***/ 24292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ success; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/Container.tsx
var Container = __webpack_require__(3210);
// EXTERNAL MODULE: ./src/components/Button.tsx
var Button = __webpack_require__(68663);
// EXTERNAL MODULE: ./src/components/SEMPage/StarsAndRatings.tsx
var SEMPage_StarsAndRatings = __webpack_require__(39925);
// EXTERNAL MODULE: ./public/img/icons/google-logo-icon.png
var google_logo_icon = __webpack_require__(32997);
;// CONCATENATED MODULE: ./public/img/expect-1.png
/* harmony default export */ var expect_1 = ({"src":"/_next/static/media/expect-1.da2ebf66.png","height":1706,"width":2472,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAVFBMVEXp6+RqZ2Q/T1JJOjmpvL0/RUeVkpKKiIihmZawp6EiLj4WHCeAQj65ysmdsrN6fYCKpqzP2NTJ0s+3uLXS2NFhR0NpeHMzMjd5cW9EFRh+foJZX2k7SdE0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAOElEQVR4nAXBBwKAIAwAsWO2BdyC6///NAFgm+LKMfzJHmeuHm5xKeFae4KpoLWWzzTzFi+WZfkBMewB6IGQy7sAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/img/expect-2.png
/* harmony default export */ var expect_2 = ({"src":"/_next/static/media/expect-2.b59e8ffe.png","height":1706,"width":2472,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAVFBMVEUAAwyIi4x5V1R3fIAQFCBAS1McISc4PERTWmBpb3UTCA6kfHOPGAcUKjlkeH1cfohDR0wdJjKlBgOLBANaaHB5bGs9EQ7bGgCfoaKxtbfJysb///w/ZitQAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAOElEQVR4nAXBhwHAIAzAMAMBEkbpnv//WYkpI7c9HyOzWNaXOFtxQTro7ms/Gym6etAuNAUvZVt/NroB8jslDP8AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/img/expect-3.png
/* harmony default export */ var expect_3 = ({"src":"/_next/static/media/expect-3.8d59ec6c.png","height":1706,"width":2472,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAaVBMVEUxIiWPTkhXUU2+vLdkODUFFCG/oofr1717UEvr3cvOwrFpbnC9YlHGsJG/rYyaeVyQiGiXWD+ifmv57uHTxbNSLSI2OT2CfnkbHydtRCtRPz2eMBsbGBnpwZ97bGiUg3hMMC7ipIr9+fMTMm26AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAOklEQVR4nAXBhQGAMADAsM4Ndxky/j+ShCk4N9RNxxhi9NK2fEo+q+kr1HKUtGnBtSPSi8fm+bwx+gdEQgKWDX5IRQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":6});
// EXTERNAL MODULE: ./public/img/nubrakes-van-house-800-num.jpg
var nubrakes_van_house_800_num = __webpack_require__(5426);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./src/components/SuccessPage/SuccessPageHeader.tsx













var SuccessPageHeader = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "py-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col justify-center align-center h-1/4",
                style: {
                    position: "relative",
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: nubrakes_van_house_800_num/* default */.Z,
                        priority: true,
                        alt: "NuBrakes Header Van Image",
                        placeholder: "blur",
                        layout: "fill",
                        objectFit: "cover",
                        objectPosition: "bottom center"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "overlay",
                        style: {
                            minHeight: "100%",
                            width: "100%",
                            position: "absolute",
                            zIndex: 1,
                            backgroundColor: "rgba(0,0,0,.75)"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            zIndex: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                            className: "pb-4 text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialProofBadge, {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatToExpectSection, {})
            })
        ]
    });
};
var WhatToExpectSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "block",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col items-center gap-1 lg:gap-4 p-3 lg:pt-6 pt-3 lg:p-8 lg:pb-8 bg-gray-50",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "max-w-xs lg:max-w-4xl",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "text-center text-xl lg:text-4xl m-0",
                            children: "what you can expect"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col lg:flex-row gap-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpectNextItem, {
                                image: expect_1,
                                title: "we come to you",
                                description: "Convenient service where you’re parked. Open 7 days, same-day service available."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpectNextItem, {
                                image: expect_2,
                                title: "Focus on quality",
                                description: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        "Expert techs, high-quality parts. ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        " Backed by our Warranty Guarantee."
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpectNextItem, {
                                image: expect_3,
                                title: "Transparent process",
                                description: "We recommend only what’s needed with upfront pricing and no hidden fees"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var PictureSection = function(param) {
    var year = param.year, othersSaying = param.othersSaying, image = param.image, _make = param.make, make = _make === void 0 ? "Chevrolet" : _make, _model = param.model, model = _model === void 0 ? "" : _model;
    return /*#__PURE__*/ _jsxs("div", {
        className: "p-8 pt-6 bg-white w-full h-full",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "mx-auto p-3 border-gray-800 bg-white",
                style: {
                    width: "100%",
                    height: 200,
                    position: "relative"
                },
                children: /*#__PURE__*/ _jsx(Image, {
                    className: "mx-auto ",
                    src: image,
                    layout: "fill",
                    objectFit: "scale-down",
                    alt: "".concat(make, " Logo Image")
                })
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "pt-3 pb-0 text-center",
                style: {
                    fontSize: 24,
                    fontWeight: "bold",
                    lineHeight: 1
                },
                children: othersSaying
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "text-center lg:hidden",
                children: /*#__PURE__*/ _jsx(StarsAndRatings, {})
            }),
            /*#__PURE__*/ _jsxs("div", {
                style: {
                    color: "#a6adb4"
                },
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "m-0",
                        children: "“Amazing service! The whole process from setting the appointment to the repairs could not have been smoother or more convenient.”"
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        children: /*#__PURE__*/ _jsx("b", {
                            children: "— Lisa S., ".concat(year, " ").concat(changeCase.capitalCase(make), " ").concat(changeCase.capitalCase(model))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "hidden lg:block",
                children: /*#__PURE__*/ _jsx(SocialProofBadge, {})
            })
        ]
    });
};
var SocialProofBadge = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col items-center justify-center p-1 lg:p-[14px] rounded-md",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex gap-5 items-center mb-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SEMPage_StarsAndRatings/* StarsAndRatings */.G, {
                        withPoints: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: google_logo_icon/* default */.Z,
                                height: 20,
                                width: 20,
                                objectPosition: "bottom center",
                                priority: true,
                                alt: "Valvoline logo"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-white",
                                children: "(14,270 Reviews)"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "text-white text-2xl lg:text-5xl max-w-xs lg:max-w-xl uppercase m-0",
                children: "a 5-star experience, coming right up!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                style: {
                    fontFamily: "IndustryInc-Base"
                },
                className: "text-base sm:w-auto py-2 mx-auto mt-3 px-6 font-normal",
                children: "Need Help? (512) 640 2560"
            })
        ]
    });
};
var ExpectNextItem = function(param) {
    var title = param.title, description = param.description, image = param.image, strongDescription = param.strongDescription;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col border rounded-md overflow-hidden w-72 bg-white",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-20 lg:h-52 w-full relative",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: image,
                    objectFit: "cover",
                    layout: "fill",
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col items-center py-2 px-4 text-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: "m-0 leading-0 text-[1.2rem] lg:text-xl leading-tight uppercase",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: classnames_default()("text-[0.93rem] lg:text-base m-0", strongDescription ? "text-[#F00C] font-semibold" : "text-[#000C]"),
                        children: description
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/FAQSection.tsx
var FAQSection = __webpack_require__(14399);
// EXTERNAL MODULE: ./node_modules/capital-case/dist.es2015/index.js + 1 modules
var dist_es2015 = __webpack_require__(71292);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/ramda/es/index.js + 240 modules
var es = __webpack_require__(61275);
// EXTERNAL MODULE: ./src/components/Layout.tsx + 1 modules
var Layout = __webpack_require__(22932);
// EXTERNAL MODULE: ./node_modules/react-modal/lib/index.js
var lib = __webpack_require__(83253);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
;// CONCATENATED MODULE: ./public/img/new_tech_home.jpg
/* harmony default export */ var new_tech_home = ({"src":"/_next/static/media/new_tech_home.f844417d.jpg","height":702,"width":1338,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAEAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAdEAABBAIDAAAAAAAAAAAAAAACAAEDBBExBRIh/8QAFAEBAAAAAAAAAAAAAAAAAAAAA//EABcRAQEBAQAAAAAAAAAAAAAAAAEAAjL/2gAMAwEAAhEDEQA/AJKVyTkJbBThFjuwuIAwsTMXmcb2iIhFn303/9k=","blurWidth":8,"blurHeight":4});
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var yup_es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/index.mjs + 1 modules
var dist = __webpack_require__(86501);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(59417);
// EXTERNAL MODULE: ./src/components/Fields/CustomTextField.tsx
var CustomTextField = __webpack_require__(12640);
// EXTERNAL MODULE: ./src/components/clients/nest-backend.client.ts
var nest_backend_client = __webpack_require__(18037);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/hooks/useQueryParam.tsx
var useQueryParam = __webpack_require__(73401);
;// CONCATENATED MODULE: ./src/components/SuccessPage/DiscountModal.tsx
















var validationSchema = yup_es/* object */.Ry().shape({
    accept: yup_es/* boolean */.O7().required("you must accept").isTrue("you must accept")
});
var DiscountModal = function(param) {
    var isOpen = param.isOpen, onRequestClose = param.onRequestClose, phoneNumber = param.phoneNumber;
    var query = (0,useQueryParam/* useQueryParam */.W)();
    var modalStyle = {
        content: {
            flexDirection: "column",
            padding: 0,
            height: "min-content",
            maxWidth: "400px",
            overflow: "visible",
            margin: "auto"
        },
        overlay: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(0, 0, 0, 0.75)",
            zIndex: 100
        }
    };
    function onSubmit(values) {
        return _onSubmit.apply(this, arguments);
    }
    function _onSubmit() {
        _onSubmit = (0,_async_to_generator/* default */.Z)(function(values) {
            var error, ref, ref1, ref2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!values.accept) return [
                            2
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            nest_backend_client/* nestBackendClient.post */.u.post("/contacts/allow-campaign-messages", {
                                phone: phoneNumber,
                                discountPromo: true
                            })
                        ];
                    case 2:
                        _state.sent();
                        onRequestClose();
                        (0,dist/* default */.ZP)("Thank you, preferences updated!", {
                            duration: 4000,
                            icon: "✅"
                        });
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        (0,dist/* default */.ZP)((ref2 = (ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) !== null && ref2 !== void 0 ? ref2 : error.message, {
                            icon: "❌",
                            duration: 2000
                        });
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _onSubmit.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((lib_default()), {
        style: modalStyle,
        isOpen: isOpen,
        onRequestClose: onRequestClose,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                onClick: onRequestClose,
                className: "absolute z-10 -top-5 -right-5 flex items-center justify-center h-10 w-10 rounded-full bg-white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: " text-[#f04f23] border-[#f04f23] border-2 rounded-full h-5 w-5 flex items-center justify-center",
                    children: "✕"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full overflow-hidden flex items-center flex-col",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-[126%]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: new_tech_home,
                        priority: true,
                        alt: "NuBrakes Header Van Image",
                        placeholder: "blur",
                        objectFit: "cover",
                        objectPosition: "bottom center"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "p-2 flex flex-col items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "w-52 text-center",
                        children: "Get 5% Off Your Quote"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                        validationSchema: validationSchema,
                        initialValues: {
                            accept: false
                        },
                        enableReinitialize: false,
                        isInitialValid: false,
                        onSubmit: onSubmit,
                        children: function(param) {
                            var isSubmitting = param.isSubmitting, isValid = param.isValid, handleSubmit = param.handleSubmit;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                                className: "flex flex-col w-full max-w-lg p-3",
                                onSubmitCapture: handleSubmit,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mb-3 flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                name: "accept",
                                                componet: CustomTextField/* CustomFormControl */.Jt,
                                                type: "checkbox",
                                                id: "accept-check",
                                                className: "w-10 h-10 border-2 rounded-lg"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTextField/* Label */.__, {
                                                className: "ml-2",
                                                htmlFor: "accept-check",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "font-normal text-[9px] mb-0",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: "Nubrakes"
                                                        }),
                                                        " By checking this box, you agree to receive promotional messages sent via an autodialer to the phone number you provided on the prior page. You also agree to the",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: {
                                                                pathname: "/terms-conditions",
                                                                query: query
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                children: "Terms of Service"
                                                            })
                                                        }),
                                                        " ",
                                                        "and ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: {
                                                                pathname: "/privacy-policy",
                                                                query: query
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                children: "Privacy Policy"
                                                            })
                                                        }),
                                                        ". Consent isn’t a condition of any purchase. Message frequency varies. Message and data rates may apply. Offer cannot be combined with other promotions; however, the highest eligible discount will be applied. Reply STOP to opt out; HELP for more information."
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                                        className: "w-full py-3 uppercase",
                                        disabled: isSubmitting || !isValid,
                                        type: "submit",
                                        id: "submit-btn",
                                        children: isSubmitting ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: free_solid_svg_icons/* faSpinner */.LM3,
                                            spin: true
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    className: "m-0",
                                                    children: "Get 5% Off"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "text-sm",
                                                    children: "When You Sign Up For Texts"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            });
                        }
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/HappinessGuaranteeSection.tsx
var HappinessGuaranteeSection = __webpack_require__(28763);
;// CONCATENATED MODULE: ./public/img/icons/shield-tick-blue.svg
/* harmony default export */ var shield_tick_blue = ({"src":"/_next/static/media/shield-tick-blue.2c0e6b25.svg","height":30,"width":30});
// EXTERNAL MODULE: ./public/img/icons/brake-icon-black.png
var brake_icon_black = __webpack_require__(61835);
// EXTERNAL MODULE: ./public/img/icons/receipt-discount-icon-black.png
var receipt_discount_icon_black = __webpack_require__(82705);
// EXTERNAL MODULE: ./public/img/icons/clock-icon-black.png
var clock_icon_black = __webpack_require__(13158);
// EXTERNAL MODULE: ./public/img/icons/document-icon-black.png
var document_icon_black = __webpack_require__(38177);
// EXTERNAL MODULE: ./public/img/icons/like-shaped-icon-black.png
var like_shaped_icon_black = __webpack_require__(29001);
// EXTERNAL MODULE: ./public/img/icons/shield-tick-icon-black.png
var shield_tick_icon_black = __webpack_require__(80734);
;// CONCATENATED MODULE: ./src/pages/success.tsx













// import { Contact } from '../generated/nest-graphql'











function getImageForMake(make) {
    var makesWithImage = [
        "acura",
        "audi",
        "bmw",
        "buick",
        "cadillac",
        "chevrolet",
        "chrysler",
        "dodge",
        "fiat",
        "ford",
        "gmc",
        "honda",
        "hyundai",
        "infiniti",
        "jaguar",
        "jeep",
        "kia",
        "lexus",
        "maserati",
        "mazda",
        "mercedes",
        "mitsubishi",
        "nissan",
        "porsche",
        "ram",
        "saab",
        "subaru",
        "suzuki",
        "tesla",
        "toyota",
        "volkswagen",
        "volvo", 
    ];
    return (0,es/* ifElse */.KJl)(function(m) {
        return makesWithImage.includes(m);
    }, function(m) {
        return "/img/".concat(m, ".png");
    }, (0,es/* always */.Bxt)("/img/nubrakes-van-house-800-num.jpg"))(make);
}
var generatePageTitle = function(firstName, year, make, model) {
    if (!year && !make && !model) return "Thank you, we've received your request!";
    return "Thank you".concat(firstName ? " ".concat(firstName) : "", ", We've received your quote request for your ").concat(year, " ").concat(make, " ").concat(model, "!");
};
var generateTestimonialText = function(make) {
    if (!make) return "Here's what other customers are saying about NuBrakes: ";
    return "Here's What Other ".concat(dist_es2015/* capitalCase */.I(make), " Customers Are Saying About NuBrakes:");
};
var SuccessPageTemplate = function(param) {
    var make = param.make, model = param.model, firstName = param.firstName, year = param.year, phoneNumber = param.phoneNumber;
    var closeModal = function closeModal() {
        setIsOpen(false);
    };
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), modalIsOpen = ref[0], setIsOpen = ref[1];
    // const [contact, setContact] = React.useState<Contact>()
    // const [isLoading, setIsloading] = React.useState(true)
    var getData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        if (!phoneNumber) return [
                            2
                        ];
                        return [
                            4,
                            nest_backend_client/* nestBackendClient.get */.u.get("/contacts/public/by-phone-number", {
                                params: {
                                    phone: phoneNumber
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        // setIsloading(false)
        });
        return function getData() {
            return _ref.apply(this, arguments);
        };
    }();
    react.useEffect(function() {
        getData();
    }, [
        phoneNumber
    ]);
    react.useEffect(function() {
        if (phoneNumber) {
            setIsOpen(true);
        } else {
            setIsOpen(false);
        }
    }, [
        phoneNumber
    ]);
    var image = getImageForMake(make);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessPageHeader, {
                year: year,
                title: generatePageTitle(firstName, year, make, model),
                make: make,
                image: image,
                othersSaying: generateTestimonialText(make),
                model: model,
                firstName: firstName
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscountModal, {
                onRequestClose: closeModal,
                isOpen: modalIsOpen,
                phoneNumber: phoneNumber
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewsSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IncludeInAllServicesSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQSection/* FAQSection */.v, {
                title: "Frequently Asked Questions",
                description: ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HappinessGuaranteeSection/* HappinessGuaranteeSection */.M, {
                backgroundColor: "#FFF",
                title: "HAPPINESS GUARANTEED",
                description: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        "Our brake techs have decades of combined experience, and all services are backed by our",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            className: "text-[#f04f23]",
                            children: "NuBrakes Guarantee."
                        })
                    ]
                })
            })
        ]
    });
};
var SuccessPage = function() {
    var router = (0,next_router.useRouter)();
    var _query = router.query, _vehicleYear = _query.vehicleYear, vehicleYear = _vehicleYear === void 0 ? "" : _vehicleYear, _vehicleMake = _query.vehicleMake, vehicleMake = _vehicleMake === void 0 ? "" : _vehicleMake, _vehicleModel = _query.vehicleModel, vehicleModel = _vehicleModel === void 0 ? "" : _vehicleModel, _firstName = _query.firstName, firstName = _firstName === void 0 ? "" : _firstName, _phoneNumber = _query.phoneNumber, phoneNumber = _phoneNumber === void 0 ? "" : _phoneNumber;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        title: "Success! | NuBrakes Mobile Brake Repair",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        src: "https://storyprompt.com/js/iframeResizer.min.js",
                        defer: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        src: "https://storyprompt.com/js/iframeResizer.min.js",
                        async: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "noindex,nofollow"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessPageTemplate, {
                make: vehicleMake,
                model: vehicleModel,
                firstName: firstName,
                year: vehicleYear,
                phoneNumber: phoneNumber
            })
        ]
    });
};
var ReviewsSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        className: "h-full mt-5",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col items-center h-full",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-black text-2xl lg:text-4xl max-w-lg text-center",
                    children: "Trusted By 100,000+ Customers Just Like You"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center justify-center mb-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: shield_tick_blue,
                            height: 30,
                            width: 30,
                            alt: "shield security icon"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-sm capitalize",
                            children: "NuBrakes never offers incentives for reviews"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                    loading: "eager",
                    id: "SP_cmFDSnceVq2r7aASVGuT",
                    src: "https://storyprompt.com/wall/iNyNnwLvMy5bxfSiRaTN",
                    frameBorder: "0",
                    width: "100%",
                    //height="100vh"
                    height: "600px"
                })
            ]
        })
    });
};
var everyServices = [
    {
        icon: clock_icon_black/* default */.Z,
        title: "mobile service",
        description: "Save 3+ hours"
    },
    {
        icon: document_icon_black/* default */.Z,
        title: "Free inspection",
        description: "Only Repairs You Need"
    },
    {
        icon: brake_icon_black/* default */.Z,
        title: "Premium parts",
        description: "Manufacturer Quality"
    },
    {
        icon: like_shaped_icon_black/* default */.Z,
        title: "Warranty guarantee",
        description: "For Peace of Mind"
    },
    {
        icon: receipt_discount_icon_black/* default */.Z,
        title: "Up front pricing",
        description: "No Nasty Surprises"
    },
    {
        icon: shield_tick_icon_black/* default */.Z,
        title: "Expert techs",
        description: "Decades of Experience"
    }, 
];
var IncludeInAllServicesSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-gray-50",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            className: " text-center pt-7 flex flex-col",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                    className: "text-black text-2xl lg:text-4xl w-full",
                    children: [
                        "Included ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        " with every service"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid grid-cols-2 lg:grid-cols-3 gap-3 my-3 w-full",
                    children: everyServices.map(function(service, idx) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "border flex flex-col items-center h-full bg-white rounded-xl py-6 px-2 lg:px-4 w-full",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        width: 61,
                                        height: 61,
                                        src: service.icon
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    className: "text-[#f04f23] text-sm lg:text-base m-0",
                                    children: service.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "m-0 mt-auto text-sm",
                                    children: service.description
                                })
                            ]
                        }, idx);
                    })
                })
            ]
        })
    });
};
var __N_SSP = true;
/* harmony default export */ var success = (SuccessPage);


/***/ }),

/***/ 64396:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(45697);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(93967);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StarRatingComponent = function (_Component) {
  _inherits(StarRatingComponent, _Component);

  function StarRatingComponent(props) {
    _classCallCheck(this, StarRatingComponent);

    var _this = _possibleConstructorReturn(this, (StarRatingComponent.__proto__ || Object.getPrototypeOf(StarRatingComponent)).call(this));

    _this.state = {
      value: props.value
    };
    return _this;
  }

  _createClass(StarRatingComponent, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var value = nextProps.value;


      if (value != null && value !== this.state.value) {
        this.setState({ value: value });
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(inputValue) {
      var _props = this.props,
          editing = _props.editing,
          value = _props.value;


      if (!editing) {
        return;
      }

      // do not update internal state based on input value if prop passed
      if (value != null) {
        return;
      }

      this.setState({ value: inputValue });
    }
  }, {
    key: 'onStarClick',
    value: function onStarClick(index, value, name, e) {
      e.stopPropagation();

      var _props2 = this.props,
          onStarClick = _props2.onStarClick,
          editing = _props2.editing;


      if (!editing) {
        return;
      }

      onStarClick && onStarClick(index, value, name, e);
    }
  }, {
    key: 'onStarHover',
    value: function onStarHover(index, value, name, e) {
      e.stopPropagation();

      var _props3 = this.props,
          onStarHover = _props3.onStarHover,
          editing = _props3.editing;


      if (!editing) {
        return;
      }

      onStarHover && onStarHover(index, value, name, e);
    }
  }, {
    key: 'onStarHoverOut',
    value: function onStarHoverOut(index, value, name, e) {
      e.stopPropagation();

      var _props4 = this.props,
          onStarHoverOut = _props4.onStarHoverOut,
          editing = _props4.editing;


      if (!editing) {
        return;
      }

      onStarHoverOut && onStarHoverOut(index, value, name, e);
    }
  }, {
    key: 'renderStars',
    value: function renderStars() {
      var _this2 = this;

      var _props5 = this.props,
          name = _props5.name,
          starCount = _props5.starCount,
          starColor = _props5.starColor,
          emptyStarColor = _props5.emptyStarColor,
          editing = _props5.editing;
      var value = this.state.value;


      var starStyles = function starStyles(i, value) {
        return {
          float: 'right',
          cursor: editing ? 'pointer' : 'default',
          color: value >= i ? starColor : emptyStarColor
        };
      };
      var radioStyles = {
        display: 'none',
        position: 'absolute',
        marginLeft: -9999
      };

      // populate stars
      var starNodes = [];

      var _loop = function _loop(i) {
        var id = name + '_' + i;
        var starNodeInput = _react2.default.createElement('input', {
          key: 'input_' + id,
          style: radioStyles,
          className: 'dv-star-rating-input',
          type: 'radio',
          name: name,
          id: id,
          value: i,
          checked: value === i,
          onChange: _this2.onChange.bind(_this2, i, name)
        });
        var starNodeLabel = _react2.default.createElement(
          'label',
          {
            key: 'label_' + id,
            style: starStyles(i, value),
            className: 'dv-star-rating-star ' + (value >= i ? 'dv-star-rating-full-star' : 'dv-star-rating-empty-star'),
            htmlFor: id,
            onClick: function onClick(e) {
              return _this2.onStarClick(i, value, name, e);
            },
            onMouseOver: function onMouseOver(e) {
              return _this2.onStarHover(i, value, name, e);
            },
            onMouseLeave: function onMouseLeave(e) {
              return _this2.onStarHoverOut(i, value, name, e);
            }
          },
          _this2.renderIcon(i, value, name, id)
        );

        starNodes.push(starNodeInput);
        starNodes.push(starNodeLabel);
      };

      for (var i = starCount; i > 0; i--) {
        _loop(i);
      }

      return starNodes.length ? starNodes : null;
    }
  }, {
    key: 'renderIcon',
    value: function renderIcon(index, value, name, id) {
      var _props6 = this.props,
          renderStarIcon = _props6.renderStarIcon,
          renderStarIconHalf = _props6.renderStarIconHalf;


      if (typeof renderStarIconHalf === 'function' && Math.ceil(value) === index && value % 1 !== 0) {
        return renderStarIconHalf(index, value, name, id);
      }

      if (typeof renderStarIcon === 'function') {
        return renderStarIcon(index, value, name, id);
      }

      return _react2.default.createElement(
        'i',
        { key: 'icon_' + id, style: { fontStyle: 'normal' } },
        '\u2605'
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props7 = this.props,
          editing = _props7.editing,
          className = _props7.className;

      var classes = (0, _classnames2.default)('dv-star-rating', {
        'dv-star-rating-non-editable': !editing
      }, className);

      return _react2.default.createElement(
        'div',
        { style: { display: 'inline-block', position: 'relative' }, className: classes },
        this.renderStars()
      );
    }
  }]);

  return StarRatingComponent;
}(_react.Component);

StarRatingComponent.propTypes = {
  name: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.number,
  editing: _propTypes2.default.bool,
  starCount: _propTypes2.default.number,
  starColor: _propTypes2.default.string,
  onStarClick: _propTypes2.default.func,
  onStarHover: _propTypes2.default.func,
  onStarHoverOut: _propTypes2.default.func,
  renderStarIcon: _propTypes2.default.func,
  renderStarIconHalf: _propTypes2.default.func
};
StarRatingComponent.defaultProps = {
  starCount: 5,
  editing: true,
  starColor: '#ffb400',
  emptyStarColor: '#333'
};
exports["default"] = StarRatingComponent;
module.exports = exports['default'];


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4976,7948,2978,4231,7858,8210,2932,9774,2888,179], function() { return __webpack_exec__(92449); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);